export default "__VITE_ASSET__244288f8__"